import React from 'react';
import { MentalKnowHowTextData } from '../../types';
import PageTitle from '../../components/PageTitle';

type Props = {
    knowHowText: MentalKnowHowTextData
}

export default ({ knowHowText }: Props) => (
    <>
        <PageTitle documentTitleParts={[knowHowText.mentalTitle, 'Know How', knowHowText.title]}>
            <span className="mobile-parent-title">{knowHowText.title.length > 20 ? `${knowHowText.title.substring(0, 20)}...` : knowHowText.title}</span>
            <span className="parent-title">{knowHowText.title}</span>
            <strong>Know how</strong>
        </PageTitle>
        <h2>{knowHowText.title}</h2>
        <div>
            {knowHowText.text}
        </div>
    </>
);
